module.exports = __webpack_public_path__ + "static/media/criminologist.1259fd1d.jpg";